import { render, staticRenderFns } from "./DesktopCalendar.vue?vue&type=template&id=586ee762&scoped=true&"
import script from "./DesktopCalendar.vue?vue&type=script&lang=js&"
export * from "./DesktopCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DesktopCalendar.vue?vue&type=style&index=0&id=586ee762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586ee762",
  null
  
)

export default component.exports